import React from 'react';

// Pill-shaped segmented mode switch (design-recreation mockup): dark track,
// active segment is a raised vein pill with aurum-bright text.
// Used for CREATE's NEW SCAN / NEW GLOWUP, the Vault's SCANS / GLOWUPS,
// and the mobile create SCAN / GLOWUP toggle.
//
// Props:
//   options  [{ key, label, icon? }]   icon is a rendered element
//   active   key of the active option
//   onChange (key) => void
//   size     'md' (desktop, px-22 py-12) | 'sm' (mobile, slimmer)
//   stretch  segments share width equally (mobile full-width toggle)
const SegmentedSwitch = ({ options, active, onChange, size = 'md', stretch = false, className = '' }) => {
  const pad = size === 'sm' ? 'px-4 py-[11px]' : 'px-[22px] py-3';
  const text = size === 'sm' ? 'text-[11px]' : 'text-xs';
  return (
    <div
      role="tablist"
      className={[
        'flex gap-1 bg-[#161616] border border-[rgba(255,255,255,0.10)] rounded-full p-[5px]',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {options.map((opt) => {
        const isActive = opt.key === active;
        return (
          <button
            key={opt.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(opt.key)}
            className={[
              'flex items-center justify-center gap-2.5 border-0 rounded-full cursor-pointer',
              'font-display uppercase tracking-[0.22em] transition-colors duration-200 ease-mogged',
              pad,
              text,
              stretch ? 'flex-1' : '',
              isActive ? 'bg-vein text-aurum-bright' : 'bg-transparent text-bone-dim hover:text-bone',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {opt.icon && (
              <span className="inline-flex items-center justify-center" aria-hidden="true">
                {opt.icon}
              </span>
            )}
            <span>{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default SegmentedSwitch;
